module.exports = __webpack_public_path__ + "static/img/Information-banner.9890c352.png";